import {styled} from "@styled-system/jsx";
import {subscript} from "@styled-system/recipes";

const Subscript = styled("p", subscript);

export default Subscript;
